import { MutableRefObject, useEffect, useRef, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";

interface ISize {
  height: number;
  width: number;
}
const useDimensions = <T extends HTMLElement>(): [ MutableRefObject<T | null>, ISize] => {
  const ref = useRef<T | null>(null);

  const [width, changeWidth] = useState(0);
  const [height, changeHeight] = useState(0);

  useEffect((): any => {
    const element = ref.current;
    const resizeObserver = new ResizeObserver((entries: any[]) => {

      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }

        const entry = entries[0];

        if (width !== entry.contentRect.width) {
          changeWidth(entry.contentRect.width);
        }
        if (height !== entry.contentRect.height) {
          changeHeight(entry.contentRect.height);
        }
      });
    });

    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
    };
  }, [height, width]);

  return [ref, { width, height }];
};

export default useDimensions;